import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import config from '../../config';
import { headers } from '../../token';
import vAdminformat from '../../adminFormat';
import validateError from '../../ValidateError';
import ColorBox from '../ColorBox';

const server_backend = config.API_URL;

function UpdateMouldAuth({ username, onMouldFileID, onClose, getMouldLibrary }) {
    const [loading, setLoading] = useState(false);
    const [userCreated, setUserCreated] = useState("");
    const [userModify, setUserModify] = useState("");
    const [dateCreated, setDateCreated] = useState("");
    const [dateModify, setDateModify] = useState("");
    const [formData, setFormData] = useState({
    });
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [isDragging, setIsDragging] = useState(false);
    const [getMouldTypes, setGetMouldTypes] = useState([]);
    const [getMouldOrigins, setGetMouldOrigins] = useState([]);
    const [getMouldConditions, setGetMouldConditions] = useState([]);
    const [materialList, setMaterialList] = useState([]);
    const [selectedMaterial, setSelectedMaterial] = useState(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const [isInitialized, setIsInitialized] = useState(false); // Flag to check if the material has been initialized

    useEffect(() => {
        const getMouldFile = async () => {
            try {
                const response = await axios.get(`${server_backend}/files/moulds/public/select?id=${onMouldFileID}`, headers);

                if (response.data.RES_CODE === "00") {
                    const data = response.data.RES_RESULT[0];
                    setUserCreated(data.user_created);
                    setUserModify(data.user_modify);
                    setDateCreated(data.date_created);
                    setDateModify(data.date_modify);
                    setFormData({
                        ...data,
                        est_id: data.est_ID,
                        id: onMouldFileID
                    });
                }
            } catch (error) {
                console.log(error);
            }
        };
        getMouldFile();
    }, [onMouldFileID, username]);

    useEffect(() => {
        const getMouldType = async () => {
            try {
                const response = await axios.get(`${server_backend}/mould_types/list`, headers);
                //console.log({MouldType: response.data});

                if (response.data.RES_CODE === "00") {
                    setGetMouldTypes(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log(error)
            }
        }
        getMouldType();
    }, []);

    useEffect(() => {
        const getMouldConditions = async () => {
            try {
                const response = await axios.get(`${server_backend}/mould_conditions/list`, headers);
                //console.log({MouldType: response.data});

                if (response.data.RES_CODE === "00") {
                    setGetMouldConditions(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log(error)
            }
        }
        getMouldConditions();
    }, []);

    useEffect(() => {
        const getMouldOrigins = async () => {
            try {
                const response = await axios.get(`${server_backend}/mould_origins/list`, headers);
                //console.log({MouldType: response.data});

                if (response.data.RES_CODE === "00") {
                    setGetMouldOrigins(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log(error)
            }
        }
        getMouldOrigins();
    }, []);

    useEffect(() => {
        const getMaterial = async () => {
            try {
                const response = await axios.get(`${server_backend}/materials/list`, headers);
                if (response.data.RES_CODE === "00") {
                    setMaterialList(response.data.RES_RESULT);

                    setFormData((prevData) => ({
                        ...prevData,
                        mat_id: response.data.RES_RESULT[0].mat_ID,
                    }));
                }
            } catch (error) {
                console.log(error)
            }
        }
        getMaterial();
    }, []);

    //These two hooks are used to correctly select the first material once the corresponding variables have been updated.
    useEffect(() => {
        if (materialList && materialList.length > 0 && formData.mat_id && !isInitialized) {
            const selectedMaterial = materialList.find(material => material.mat_ID === formData.mat_id);

            if (selectedMaterial) {
                handleMaterialSelect(selectedMaterial);
                setIsInitialized(true); // Set the flag to true after selecting the material
            }
        }
    }, [materialList, formData.mat_id, isInitialized]);  

    const handleMaterialSelect = (material) => {
        setSelectedMaterial(material);
        setFormData({ ...formData, mat_id: material.mat_ID });
        setShowDropdown(false);
    };

    const handleUpdate = async (e) => {
        e.preventDefault();

        Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to update this file?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
        }).then(async (result) => {
            if (result.isConfirmed) {
                setLoading(true);
                try {
                    const response = await axios.post(`${server_backend}/files/moulds/public/update`, formData, headers);
                    if (response.data.RES_CODE === "00") {

                        Swal.fire({
                            icon: 'success',
                            title: 'Updated Successfully',
                            showConfirmButton: false,
                            timer: 1000
                        });
                        onClose()
                        getMouldLibrary()
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'There is already a file with the same name, please try with another name',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    }
                } catch (error) {
                    const message = validateError(error);

                    Swal.fire({
                        icon: 'error',
                        title: message,
                        showConfirmButton: false,
                        timer: 2000
                    });
                } finally {
                    setLoading(false);
                }
            }
        });
    };

    return (
        <div className="modal fade bs-example-modal-xl show azoomOutDown" tabIndex="-1" role="dialog" aria-labelledby="myExtraLargeModalLabel" aria-modal="true" style={{ display: "block", backgroundColor: "#0101019e" }}>
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="myExtraLargeModalLabel">Modify Mould</h5>
                        <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="tab-pane fade show active" id="pills-bill-info" role="tabpanel" aria-labelledby="pills-bill-info-tab">
                            <div className="live-preview">
                                <form onSubmit={handleUpdate}>
                                    <div className="row">
                                        <div className="card-body">
                                            <div className="col-12">
                                                <div className="row">
                                                    <div className="col-12">
                                                        <div className="row mt-2">
                                                            <div className="col-md-6 mb-3">
                                                                <label className="form-label fw-bold">Mould Name </label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    onChange={(e) => setFormData({ ...formData, mould_name: e.target.value })}
                                                                    value={formData.mould_name} />
                                                            </div>

                                                            <div className="col-md-6 mb-3">
                                                                <label className="form-label fw-bold">Reference</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    onChange={(e) => setFormData({ ...formData, mould_reference: e.target.value })}
                                                                    value={formData.mould_reference} />
                                                            </div>

                                                            <div className="col-md-12 mb-3">
                                                                <label className="form-label fw-bold">Description</label>
                                                                <textarea
                                                                    className="form-control"
                                                                    rows={3}
                                                                    onChange={(e) => setFormData({ ...formData, comment: e.target.value })}
                                                                    value={formData.comment}
                                                                ></textarea>
                                                            </div>


                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div className="row">
                                                    <div className="col-md-4 mb-3">
                                                        <label className="form-label fw-bold">Type of Mould</label>
                                                        <select
                                                            className="form-select"
                                                            onChange={(e) => setFormData({ ...formData, mould_type: e.target.value })}
                                                            value={formData.mould_type}
                                                        >
                                                            <option value={0}>Select Type</option>

                                                            {getMouldTypes && getMouldTypes.length > 0 ? (
                                                                getMouldTypes.map((type) => (
                                                                    <option key={type.mti_ID} value={type.mti_ID}>{type.name}</option>
                                                                ))
                                                            ) : (
                                                                <option value="">No types available</option>
                                                            )}
                                                        </select>
                                                    </div>

                                                    <div className="col-md-4 mb-3">
                                                        <label className="form-label fw-bold">Mould Origin</label>
                                                        <select
                                                            className="form-select"
                                                            onChange={(e) => setFormData({ ...formData, mould_origin: e.target.value })}
                                                            value={formData.mould_origin}
                                                        >
                                                            <option value={0}>Select Origin</option>

                                                            {getMouldOrigins && getMouldOrigins.length > 0 ? (
                                                                getMouldOrigins.map((origin) => (
                                                                    <option key={origin.mti_ID} value={origin.mti_ID}>{origin.name}</option>
                                                                ))
                                                            ) : (
                                                                <option value="">No origins available</option>
                                                            )}
                                                        </select>
                                                    </div>

                                                    <div className="col-md-4 mb-3">
                                                        <label className="form-label fw-bold">Condition</label>
                                                        <select
                                                            className="form-select"
                                                            onChange={(e) => setFormData({ ...formData, mould_condition: e.target.value })}
                                                            value={formData.mould_condition}
                                                        >
                                                            <option value={0}>Select Condition</option>
                                                            {getMouldConditions && getMouldConditions.length > 0 ? (
                                                                getMouldConditions.map((condition) => (
                                                                    <option key={condition.mti_ID} value={condition.mti_ID}>{condition.name}</option>
                                                                ))
                                                            ) : (
                                                                <option value="">No conditions available</option>
                                                            )}
                                                        </select>
                                                    </div>

                                                    <div className="col-6 ">
                                                        <label className="form-label fw-bold text-muted">Metal</label>
                                                        <div
                                                            style={{
                                                                minHeight: '14vh',
                                                                height: '14vh',
                                                                border: '1px solid #dcdcdc',
                                                                padding: "5px",
                                                                width: "100%",
                                                                overflowY: 'auto',
                                                            }}
                                                        >
                                                            {materialList && materialList.length > 0 ? (
                                                                materialList.map((material) => (
                                                                    <button
                                                                        key={material.mat_ID}
                                                                        className={`dropdown-item d-flex align-items-center justify-content-between ${selectedMaterial?.mat_ID === material.mat_ID ? 'bg-primary text-white' : ''}`}
                                                                        type="button"
                                                                        onClick={() => {
                                                                            handleMaterialSelect(material);
                                                                        }}
                                                                    >
                                                                        <div className="d-flex align-items-center">
                                                                            <ColorBox color={material.color} />
                                                                            <span className="ms-2">{material.name}</span>
                                                                        </div>
                                                                    </button>
                                                                ))
                                                            ) : (
                                                                <button className="dropdown-item" type="button" disabled>
                                                                    No materials found
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label fw-bold">Size</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            onChange={(e) => setFormData({ ...formData, mould_size: e.target.value })}
                                                            value={formData.mould_size}
                                                        />
                                                    </div>
                                                </div>
                                            </div>



                                        </div>
                                        {/* User Info */}
                                        <h4 className='p-4'>Other Information</h4>
                                        <div className="col-6">
                                            <div className="mb-3">
                                                <label htmlFor="user_transaction" className="form-label">Date Created</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="user_transaction"
                                                    value={vAdminformat.FormatDate(dateCreated)}
                                                    name="user_transaction"
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="mb-3">
                                                <label htmlFor="user_transaction" className="form-label">User Created</label>
                                                <input
                                                    type="text"
                                                    className="form-control"

                                                    id="user_transaction"
                                                    value={userCreated}
                                                    name="user_transaction"
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="mb-3">
                                                <label htmlFor="user_transaction" className="form-label">Date Modified</label>
                                                <input
                                                    type="text"
                                                    className="form-control"

                                                    id="user_transaction"
                                                    value={dateModify && vAdminformat.FormatDate(dateModify)}
                                                    name="user_transaction"
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="mb-3">
                                                <label htmlFor="user_transaction" className="form-label">User Modified</label>
                                                <input
                                                    type="text"
                                                    className="form-control"

                                                    id="user_transaction"
                                                    value={userModify}
                                                    name="user_transaction"
                                                    disabled
                                                />
                                            </div>
                                        </div>

                                        <div className="card-header align-items-center d-flex">
                                            <div className="col-md-12">
                                                <div className="text-end">
                                                    <button className='btn btn-danger' style={{ marginRight: "5px" }} onClick={onClose}>
                                                        Discard changes
                                                    </button>
                                                    <button type="submit" className="btn btn-primary" disabled={loading}>
                                                        {loading ? 'Loading...' : 'Submit'}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UpdateMouldAuth;
